import { parsePhoneNumberFromString } from "libphonenumber-js";

// Kept out of util/helpers.js on purpose: helpers.js is imported across the whole app, and
// bundling libphonenumber-js there duplicates its metadata into every chunk that uses it.
// Only the views that render VuePhoneNumberInput should pull this module in.

// Splits a stored phone number into the two parts VuePhoneNumberInput needs:
// a country for `default-country-code` and a national number for `v-model`.
// The component ignores the country it parses itself whenever `default-country-code`
// is bound, so the caller has to resolve it up front.
//
// `defaultCountry` is what legacy rows are read as when they carry no `+` prefix
// (e.g. "0701234567" predates this format). An explicit `+` in the value always wins.
//
// Returns null when the number cannot be parsed into a valid one. Callers must treat
// that as "unusable" and block the save — never send the raw value to the backend,
// which only accepts the international format `formatted` produces.
function parsePhone(phone, defaultCountry = "SE") {
  const parsed = phone ? parsePhoneNumberFromString(phone, defaultCountry) : null;

  if (!parsed || !parsed.country || !parsed.isValid()) {
    return null;
  }

  return {
    countryCode: parsed.country,
    nationalNumber: parsed.nationalNumber,
    formatted: parsed.formatInternational(),
  };
}

export { parsePhone };
